module.exports = __webpack_public_path__ + "static/media/goblin_chief_head.27b515a9.svg";